import { render } from "./Invoices.vue?vue&type=template&id=3bb4b220&scoped=true"
import script from "./Invoices.vue?vue&type=script&lang=js"
export * from "./Invoices.vue?vue&type=script&lang=js"

import "./Invoices.vue?vue&type=style&index=0&id=3bb4b220&scoped=true&lang=sass"
script.render = render
script.__scopeId = "data-v-3bb4b220"

export default script